import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import { chDeleteDoctorNetworkMutation as TMutation } from "@/modules/patients/services/ch/__generated__/chDeleteDoctorNetworkMutation.graphql"

export const chDeleteDoctorNetworkMutation = graphql`
  mutation chDeleteDoctorNetworkMutation($input: Ch_deleteDoctorNetworkInput!) {
    deleteDoctorNetwork: ch_deleteDoctorNetwork(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on DoctorNetworkNotFound {
          doctorNetworkId
          message
        }
      }
      doctorNetwork {
        createdAt
        patientId
        role
      }
    }
  }
`

export const useChDeleteDoctorNetworkMutation = () => {
  return useMutation<TMutation>(chDeleteDoctorNetworkMutation)
}
